<section class="resources">
    <h2>Recursos & Mídia</h2>
    <div class="cards">
        <a href="https://www.google.com/url?q=https://drive.google.com/drive/u/5/folders/1WyYiSuIDzaP58ec_VzfnJsrT6YO-4NVI&sa=D&source=editors&ust=1757668848430128&usg=AOvVaw38Iq-unxILwqi8Airj83NC" target="_blank">
            <mat-card>
                <mat-card-content>
                    <img src="assets/icons/resources/release.png" alt="picture">
                    <p>Release</p>
                    <!-- <img src="assets/mascotes/como-comecou.png" alt=""> -->
                </mat-card-content>
            </mat-card>
        </a>
        <a href="https://www.google.com/url?q=https://drive.google.com/drive/u/5/folders/1y0hSCTDofpuOB2yiLx_MfzXUhEDVhJmo&sa=D&source=editors&ust=1757668848430231&usg=AOvVaw3h1a9HhUZXHUWs8vXdMs1z" target="_blank">
            <mat-card>
                <mat-card-content>
                    <img src="assets/icons/resources/fotos.png" alt="picture">
                    <p>Fotos e vídeos</p>
                </mat-card-content>
            </mat-card>
        </a>
        <a href="https://www.google.com/url?q=https://drive.google.com/drive/u/5/folders/1ygKOi-fliunQd9Dfj1q6SUSki_D23mj2&sa=D&source=editors&ust=1757668848430283&usg=AOvVaw3Me8vVRzB27EfXHDVYQf0s" target="_blank">
            <mat-card>
                <mat-card-content>
                    <img src="assets/icons/resources/logos.png" alt="picture">
                    <p>Logos</p>
                </mat-card-content>
            </mat-card>
        </a>

        <a target="_blank" [routerLink]="['/embaixadores']">
            <mat-card>
                <mat-card-content>
                    <img src="assets/icons/resources/porta-vozes.png" alt="picture">

                    <p>Porta-vozes</p>
                </mat-card-content>
            </mat-card>
        </a>
    </div>
</section>